import { GridFooterCellProps } from '@progress/kendo-react-grid';

const InvoiceBudgetPeriodFooterCell = (props: GridFooterCellProps) => (
  <td>
    <p className="text-left">Total</p>
  </td>
);

export default InvoiceBudgetPeriodFooterCell;
